export const basic = {
  project: {
    label: 'Project',
    placeholder: 'Choose project',
    system: {
      name: 'project',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'project',
    rules: {
      title: 'Customer contact field',
      required: true,
    }
  },
  contacts: {
    label: 'Customer contacts',
    placeholder: 'Select contacts',
    system: {
      name: 'contacts',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'contacts',
    rules: {
      title: 'Customer contacts field',
      custom: {
        message: 'Customer contacts field is required',
        onValidate: value => Array.isArray(value) && value.length > 0
      }
    }
  },
  project_id: {
    label: 'Customer',
    placeholder: 'Choose customer',
    system: {
      name: 'project_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'project_id',
    rules: {
      required: true,
    }
  },
  sales_rep_id: {
    label: 'Sales Rep',
    placeholder: 'Choose sales rep',
    system: {
      name: 'sales_rep_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'sales_rep_id',
    rules: {
      title: 'Sales Rep field',
      required: true,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/Task/fields.js